<div class="product-lines-section">
    <div class="separator"></div>
    <p class="heading">{{ "landing.proudctline" | cxTranslate }}</p>
    <p class="description">
        <span>{{ "landing.productdeta" | cxTranslate }}</span>
        <a target="_blank" [href]="valvesLink" class="valves-site-link">{{ "landing.productvalvesite" | cxTranslate }} <i class='material-icons ml-1'>open_in_new</i></a>
    </p>
    <div class="product-categories-container row">
        <div class="tile-container col-sm-12 col-lg-6 col-xl-3 pr-0 masoneilan-container">
            <div class="category-tile">
                <div class="tile-bg masoneilan"></div>
                <div class="mask"></div>
                <div class="category-info p-3">
                    <!-- <img src="../../../../../assets/img/brand-logos/bh-masoneilan.svg"> -->
                    <div class="category-logo masoneilan-logo"></div>
                    <div class="category-desc mt-2 mb-1">
                        {{ "landing.productcentury" | cxTranslate }}
                    </div>
                    <button class="vs-tertiary-btn mt-2" (click)="redirectToProductCategory(productLines.MASONEILAN)">{{ "landing.viewProd" | cxTranslate }} </button>
                </div>
            </div>
        </div>

        <div class="tile-container col-sm-12 col-lg-6 col-xl-3 pr-0 consolidated-container">
            <div class="category-tile">
                <div class="tile-bg consolidated"></div>
                <div class="mask"></div>
                <div class="category-info p-3">
                    <div class="category-logo consolidated-logo"></div>
                    <div class="category-desc mt-2 mb-1">
                        {{ "landing.productcelebrating" | cxTranslate }}
                    </div>
                    <button class="vs-tertiary-btn mt-2" (click)="redirectToProductCategory(productLines.CONSOLIDATED)">{{ "landing.viewProd" | cxTranslate }}</button>
                </div>
            </div>
        </div>

        <div class="tile-container col-sm-12 col-lg-6 col-xl-3 pr-0 becker-container">
            <div class="category-tile">
                <div class="tile-bg becker"></div>
                <div class="mask"></div>
                <div class="category-info p-3">
                    <div class="category-logo becker-logo"></div>
                    <div class="category-desc mt-2 mb-1">
                        {{ "landing.producteliminate" | cxTranslate }} 
                    </div>
                    <button class="vs-tertiary-btn mt-2" (click)="redirectToProductCategory(productLines.BECKER)">{{ "landing.viewProd" | cxTranslate }} </button>
                </div>
            </div>
        </div>

        <div class="tile-container col-sm-12 col-lg-6 col-xl-3 pr-0 mooney-container">
            <div class="category-tile">
                <div class="tile-bg mooney"></div>
                <div class="mask"></div>
                <div class="category-info p-3">
                    <div class="category-logo mooney-logo"></div>
                    <div class="category-desc mt-2 mb-1">
                        {{ "landing.productcen" | cxTranslate }}  
                    </div>
                    <button class="vs-tertiary-btn mt-2" (click)="redirectToProductCategory(productLines.MOONEY)">{{ "landing.viewProd" | cxTranslate }} </button>
                </div>
            </div>
        </div>

    </div>
</div>